import TradeNewsItem from './TradeNewsItem.jsx';

export default TradeNewsItem;


// WEBPACK FOOTER //
// ./components/partials/tradenews/index.js